<template>
  <div
    v-if="data"
    class="lg:flex justify-center"
    @mouseenter="
      setCursor('', () => {}, {
        'font-size': '14px',
        background: '#FFC800',
        width: '25px',
        height: '25px',
        'z-index': '-1',
        position: 'absolute',
      })
    "
  >
    <div class="max-w-7xl">
      <div>
        <h2 class="px-6 pb-6 lg:pb-12">
          {{ $t("about.team.founders") }}
        </h2>
      </div>

      <div
        v-if="width > 1024"
        class="lg:grid grid-cols-3 gap-y-16 px-6 people-carousel"
      >
        <NewTeamMember
          v-for="(member, i) in data.teams?.edges
            .map((edge) => edge.node)
            ?.filter(
              (team) =>
                team.teamconfiguration?.position === 'Spoluzakladatel' ||
                team.teamconfiguration?.position === 'Co-founder'
            )
            .sort((a, b) => {
              const orderA = a.teamconfiguration?.order;
              const orderB = b.teamconfiguration?.order;

              // Both values are null or undefined, keep original order
              if (orderA === null || orderA === undefined) {
                return orderB === null || orderB === undefined ? 0 : 1;
              }
              if (orderB === null || orderB === undefined) {
                return -1;
              }

              // Both values are defined, sort numerically
              return orderA - orderB;
            })"
          :key="i"
          :member="member"
          :class="{ 'mt-12': i % 2 }"
          @click="handleMemberClick(member)"
          @mouseenter="
            setCursor($t('read-more'), () => {}, {
              'font-size': '14px',
              width: '100px',
              height: '100px',
            })
          "
          @mouseleave="
            setCursor('', () => {}, {
              'font-size': '14px',
              background: '#FFC800',
              width: '25px',
              height: '25px',
              'z-index': '-1',
              position: 'absolute',
            })
          "
        />
      </div>
      <div v-if="width < 1024" class="px-6">
        <Carousel
          v-bind="settings"
          :breakpoints="breakpoints"
          :transition="500"
          class="lg:cursor-none"
          @slide-end="handleSlideEnd"
          @slide-start="handleSlideStart"
        >
          <Slide
            v-for="(member, i) in data.teams?.edges
              .map((edge) => edge.node)
              ?.filter(
                (team) =>
                  team.teamconfiguration?.position === 'Spoluzakladatel' ||
                  team.teamconfiguration?.position === 'Co-founder'
              )
              .filter((team) => team.title !== 'Recepce')
              .sort((a, b) => {
                const orderA = a.teamconfiguration?.order;
                const orderB = b.teamconfiguration?.order;

                // Both values are null or undefined, keep original order
                if (orderA === null || orderA === undefined) {
                  return orderB === null || orderB === undefined ? 0 : 1;
                }
                if (orderB === null || orderB === undefined) {
                  return -1;
                }

                // Both values are defined, sort numerically
                return orderA - orderB;
              })"
            :key="i + 'founders'"
            ref="sliderefsFounders"
          >
            <NewTeamMember
              :member="member"
              @click="handleMemberClick(member)"
            />
          </Slide>
        </Carousel>
      </div>

      <div class="negative-b-margin">
        <h2 class="px-6 pb-6 pt-10 lg:pb-12 lg:pt-16">
          {{ $t("about.team.team") }}
        </h2>
      </div>

      <Carousel
        v-bind="settings"
        :breakpoints="breakpoints"
        wrap-around
        :model-value="0"
        :transition="500"
        class="px-0"
        @slide-end="handleSlideEnd"
        @slide-start="handleSlideStart"
      >
        <Slide
          v-for="(member, i) in data.teams?.edges
            .map((edge) => edge.node)
            ?.filter(
              (team) => team.teamconfiguration?.position !== 'Spoluzakladatel'
            )
            ?.filter(
              (team) => team.teamconfiguration?.position !== 'Co-founder'
            )
            .filter((team) => team.title !== 'Recepce')
            .sort((a, b) => {
              const orderA = a.teamconfiguration?.order;
              const orderB = b.teamconfiguration?.order;

              // Both values are null or undefined, keep original order
              if (orderA === null || orderA === undefined) {
                return orderB === null || orderB === undefined ? 0 : 1;
              }
              if (orderB === null || orderB === undefined) {
                return -1;
              }

              // Both values are defined, sort numerically
              return orderA - orderB;
            })"
          :key="i"
          ref="sliderefs"
        >
          <NewTeamMember
            :member="member"
            @click="handleMemberClick(member)"
            @mouseenter="
              setCursor($t('read-more'), scrollTo, {
                'font-size': '14px',
                width: '100px',
                height: '100px',
                cursor: 'none',
              })
            "
            @mouseleave="setCursor('', null, null)"
          />
        </Slide>

        ...
      </Carousel>

      <div class="flex justify-center pb-20 pt-12 lg:pb-36">
        <a
          href="https://www.cocuma.cz/company/opero/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button
            class="pointer-events-auto bg-white border rounded-full border-black px-4 py-2 text-sm whitespace-nowrap"
          >
            {{ $t("about.team.button") }}
          </button>
        </a>
      </div>
    </div>
  </div>
  <TeamModal
    v-if="modalMember"
    :member="modalMember"
    :handle-member-click="handleMemberClick"
    :set-cursor="setCursor"
  />
</template>

<script setup>
const props = defineProps({ setCursor: Function, width: Number });

const modalMember = ref(null);
const handleMemberClick = (member) => {
  modalMember.value = member;
};

const settings = {
  itemsToShow: 1.3,
  snapAlign: "start",
};
const breakpoints = {
  600: {
    itemsToShow: 3.1,
  },
  1024: {
    itemsToShow: 3.2,
    snapAlign: "center",
  },
  1280: {
    itemsToShow: 3.2,
    snapAlign: "center",
  },
};

const { locale } = useI18n();

const query = gql`
  query CustomPages {
    teams(first: 1000, where: { language: ${locale.value
      .toString()
      .toUpperCase()}} ) {
      edges {
        node {
          title
          teamconfiguration {
             email
              phone
              position
              memberImage {
                sourceUrl(size: LARGE)
              }
              description
							linkedin
							subPosition
							order
          }
        }
      }
    }
  }
`;

const variables = { limit: 5 };
const { data } = await useAsyncQuery(query, variables);
</script>

<style scoped lang="scss">
.carousel__slide {
  padding: 10px;

  @media screen and (max-width: 1024px) {
    padding: 10px;
  }
}

.carousel__viewport {
  perspective: 2000px;

  margin-top: -50px;
}
.carousel {
  height: 725px;

  @media screen and (max-width: 1524px) {
    height: unset;
  }
}

.carousel__track {
  transform-style: preserve-3d;
}

.carousel__slide--sliding {
  transition: 0.5s;
}

.carousel__slide {
  margin-top: 120px;
  transform: scale(0.9) translateY(0px);
}

.carousel__slide--active ~ .carousel__slide {
  transform: scale(1);
}

.carousel__slide--prev {
  opacity: 1;
  margin-top: 80px;
  transform: scale(1) translateY(-11px);
}

.carousel__slide--next {
  opacity: 1;
  margin-top: 40px;
}

.carousel__slide--active {
  opacity: 1;
  margin-top: 100px;
  transform: scale(1) translateY(11px);
}

@media screen and (max-width: 1024px) {
  .carousel__viewport {
    perspective: 2000px;
  }
  .carousel {
    height: 750px;
  }

  @media (max-width: 1024px) {
    .carousel {
      height: 100%;
    }
  }

  @media (max-width: 768px) {
    .carousel {
      height: 100%;
    }
  }

  .carousel__track {
    transform-style: preserve-3d;
  }

  .carousel__slide--sliding {
    transition: 0.5s;
  }

  .carousel__slide {
    margin-top: 0px;
    transform: scale(1);
  }

  .carousel__slide--active ~ .carousel__slide {
    transform: scale(1);
  }

  .carousel__slide--prev {
    opacity: 1;
    margin-top: 0px;
    transform: scale(1);
  }

  .carousel__slide--next {
    opacity: 1;
    margin-top: 0px;
  }

  .carousel__slide--active {
    opacity: 1;
    margin-top: 0px;
    transform: scale(1);
  }
}

.people-carousel {
  grid-template-columns: repeat(3, minmax(0, 390px));
  column-gap: 10px;
  // justify-content: center;
}

.negative-b-margin {
  margin-bottom: -80px;

  @media screen and (max-width: 1024px) {
    margin-bottom: 0px;
  }
}
</style>

<style lang="scss">
.people-carousel .member-container {
  height: unset;
}
</style>
